module.exports = __webpack_public_path__ + "e4b0f20489871da1975af7fd9f345a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/menu-blue.png
// module id = 469
// module chunks = 0